import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@tosize/ui";
import type { FC, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<HTMLAttributes<HTMLDivElement>>;

const FinishWarning: FC<Props> = ({ children, className, ...props }) => {
	return (
		<div className={cn(className, "flex items-center text-warning")} {...props}>
			<FontAwesomeIcon icon={faExclamationTriangle} fixedWidth className="mr-2" />
			{children}
		</div>
	);
};

export default FinishWarning;
